import { createAction, props } from '@ngrx/store';
import { IFile } from 'src/app/shared/models/file/IFile';
import { IResponseMessage } from 'src/app/shared/models/response-message/IResponseMessage';

export const FilesActionsTypes = {
  DOWNLOAD_FILE: '[TICKET] Download file',
  UPLOAD_FILE: '[TICKET] Upload file',
  UPLOAD_FILE_ERROR: '[TICKET] Upload file error',
  DELETE_FILE: '[TICKET] Delete file',
  DELETE_TEMP_FILE: '[TICKET] Delete temp file'
};

export const UploadFile = createAction(FilesActionsTypes.UPLOAD_FILE, props<{ files: IFile[] }>());

export const UploadFileError = createAction(
  FilesActionsTypes.UPLOAD_FILE_ERROR,
  props<{ file: IFile; error: IResponseMessage }>()
);

export const DownloadFile = createAction(FilesActionsTypes.DOWNLOAD_FILE, props<{ relatedId: string }>());

export const DeleteFile = createAction(FilesActionsTypes.DELETE_FILE, props<{ filenames: string[] }>());

export const DeleteTempFile = createAction(FilesActionsTypes.DELETE_TEMP_FILE, props<{ fileIds: string[] }>());
